import React from 'react';
import { Alert } from 'antd';
import { Navigate, useLocation } from 'react-router-dom';

export type SupplyAccess = { modules: string[] | string; loaded: boolean };
export function supplyAllowed(access: SupplyAccess, key: string): boolean {
  return access.loaded && (access.modules === 'all' || (Array.isArray(access.modules) &&
    (access.modules.includes('supply-chain') || access.modules.includes(key))));
}
export function SupplyGate({access, permission, children}: {access: SupplyAccess; permission: string; children: React.ReactNode}) {
  if (!access.loaded) return <div>正在读取权限…</div>;
  return supplyAllowed(access, permission) ? <>{children}</> : <Alert type="warning" title="没有此功能的访问权限" />;
}
export function SupplyLegacyRedirect({to, view}: {to:string; view:string}) {
  const location=useLocation(), query=new URLSearchParams(location.search);
  query.delete('token'); query.set('view',view);
  return <Navigate replace to={`${to}?${query.toString()}${location.hash}`} />;
}
